var React = require('react');

function DeleteFull (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.482 6.519v6.666c0 .815.666 1.482 1.481 1.482h5.926c.815 0 1.481-.667 1.481-1.482V6.52H3.482zM10.889 3.555V2.074c0-.444-.296-.74-.74-.74H5.703c-.445 0-.741.296-.741.74v1.481H2v1.482h11.852V3.555h-2.963zm-1.482 0H6.445v-.74h2.962v.74z","fill":"#CFD1D6"}));
}

DeleteFull.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = DeleteFull;

DeleteFull.default = DeleteFull;
